// extracted by mini-css-extract-plugin
module.exports = {"list":"PartnershipDepoiments_list__1qftM"};